import { render, staticRenderFns } from "./ChartsPage.vue?vue&type=template&id=1b5b0764&scoped=true&"
import script from "./ChartsPage.vue?vue&type=script&lang=js&"
export * from "./ChartsPage.vue?vue&type=script&lang=js&"
import style0 from "./ChartsPage.vue?vue&type=style&index=0&id=1b5b0764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b0764",
  null
  
)

component.options.__file = "ChartsPage.vue"
export default component.exports